import { useTranslation } from 'react-i18next'

/**
 * Reusable coming-soon placeholder page.
 *
 * Used for MVP features that are not yet active (e.g. gifts, company offer).
 */
export default function ComingSoonPage() {
  const { t } = useTranslation()

  return (
    <div className="max-w-3xl mx-auto pb-12 min-h-[calc(100vh-10rem)] flex flex-col items-center justify-center">
      <section className="bg-brand-cream/95 rounded-3xl p-8 md:p-16 shadow-xl text-center w-full">
        <h1 className="font-climate text-4xl md:text-6xl text-brand-blue mb-6">
          {t('comingSoon.title')}
        </h1>
        <p className="text-gray-700 text-lg">
          {t('comingSoon.message')}
        </p>
      </section>
    </div>
  )
}
